import { Choice } from "components/Choice";
import * as S from "./styles";

import financiamentoImobiliario from "assets/images/financiamento-imobiliario.svg";
import financiamentoCredito from "assets/images/financiamento-credito.svg";
import { Page } from "components/Page";
import { BreadcrumbsProps } from "components/BreadCrumb";
import { Link } from "react-router-dom";
import { useMemo } from "react";
import { DefaultFooter } from "components/DefaultFooter";

export function Modality() {
  const breadcrumbs: BreadcrumbsProps = useMemo(() => {
    return {
      paths: [
        {
          link: "/",
          title: "Página inicial",
        },
      ],
      currentPage: "Modalidade",
    };
  }, []);

  return (
    <Page breadcrumbs={breadcrumbs}>
      <S.TitleContainer>
        <h1>
          A <b>Comparetaxa</b> vai comparar as melhores taxas do mercado para
          você!
        </h1>

        <h2>
          Vamos começar entendendo qual é o seu objetivo. Selecione a modalidade
          que deseja simular.
        </h2>
      </S.TitleContainer>

      <S.Content>
        <Link to="/financiamento">
          <Choice title="Financiar um imóvel">
            <img
              src={financiamentoImobiliario}
              alt="Opção de financiamento imobiliário"
            />
          </Choice>
        </Link>

        <Link to="/credito-com-imovel">
          <Choice title="Crédito com imóvel em garantia">
            <img
              src={financiamentoCredito}
              alt="Opção de financiamento imobiliário"
            />
          </Choice>
        </Link>
      </S.Content>
      <DefaultFooter />
    </Page>
  );
}
